import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/Hero';
import { Story } from './components/Story';
import { Pathway } from './components/Pathway';
import { BeforeAfter } from './components/BeforeAfter';
import { PainPoints } from './components/PainPoints';
import { Volumes } from './components/Volumes';
import { Toolkit } from './components/Toolkit';
import { Bonuses } from './components/Bonuses';
import { Testimonials } from './components/Testimonials';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { AuthorNote } from './components/AuthorNote';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { FloatingCta } from './components/FloatingCta';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-white font-sans text-ink" data-id="element-0" data-mp="23utadzydnu97">
      <MetaPixel data-id="element-1" data-mp="3ij65gd4jrr9g" />
      <Hero data-id="element-2" data-mp="3ijpdn24eb1aa" />
      <main data-id="element-3" data-mp="3ii4sg33z0up3">
        <Story data-id="element-4" data-mp="3mlj8uuvtnd32" />
        <Pathway data-id="element-5" data-mp="3ml12v6jcxkhy" />
        <BeforeAfter data-id="element-6" data-mp="3mkhmvvd9p66k" />
        <PainPoints data-id="element-7" data-mp="3mjzpgvevclx2" />
        <Volumes data-id="element-8" data-mp="3mj6hjr46bqdc" />
        <Toolkit data-id="element-9" data-mp="3rcj6y3gog175" />
        <Bonuses data-id="element-10" data-mp="3rbzmaezn6ypf" />
        <Testimonials data-id="element-11" data-mp="3rdkisa5iorpx" />
        <Offer data-id="element-12" data-mp="3rd18nfm3z7mg" />
        <Guarantee data-id="element-13" data-mp="3relv0hy9rk98" />
        <AuthorNote data-id="element-14" data-mp="5os92t1uy7l" />
        <Faq data-id="element-15" data-mp="4wvvprmowg9" />
        <FinalCta data-id="element-16" data-mp="4n6o4eeqtbm" />
      </main>
      <Footer data-id="element-17" data-mp="82ohezguggq" />
      <FloatingCta data-id="element-18" data-mp="2zl3c5m4yv85u" />
      <PurchasePopup data-id="element-19" data-mp="2zlli5ahfl0qy" />
    </div>;
}